/**
 * Created by piotr.pozniak@thebeaverhead.com on 26/08/2025.
 */

const getPreviousAvailable = (model, collection, payload) => {
  if (!model) {
    model = collection.find((i) => i.uuid === payload.uuid);
  }

  if (!model) {
    return false;
  }
  return Boolean(model.available || false);
};

const QuotasMiddleware = (storeAPI) => (next) => (action) => {
  const state = storeAPI.getState();
  switch (action.type) {
    case "CALENDAR_UPDATE_FULFILLED":
      action.previousAvailable = getPreviousAvailable(
        state.calendar.model,
        state.calendars.collection,
        action.payload
      );

      break;

    case "WIDGET_UPDATE_FULFILLED":
      action.previousAvailable = getPreviousAvailable(
        state.widget.model,
        state.widgets.collection,
        action.payload
      );

      break;

    case "ALERT_UPDATE_FULFILLED":
      action.previousAvailable = getPreviousAvailable(
        state.alert.model,
        state.alerts.collection,
        action.payload
      );

      break;

    case "GROUP_UPDATE_FULFILLED":
      action.previousAvailable = getPreviousAvailable(
        state.group.model,
        state.groups.collection,
        action.payload
      );
      break;
  }

  next(action);
};

export default QuotasMiddleware;
